import { IFormParsed } from '@infotech-soe/metaschema';

import { FormSource } from '../view-model/FormSource';

import FormSchemaFactory from './FormSchemaFactory';

class DefaultFormSchemaFactory extends FormSchemaFactory {
  public async get(source: FormSource): Promise<IFormParsed> {
    if (source.form) {
      return this.schemaRepository.getForm(source.category, source.form);
    }

    throw new Error(
      `Can't get form schema for form: ${source.form} in category: ${source.category}`
    );
  }
}

export default DefaultFormSchemaFactory;
